import { useQuery } from "@tanstack/react-query"
import { API } from "config"
import moment from "moment"

const useReport = (init, end) => useQuery({ queryKey: [`reports`, init, end], queryFn: async () => {
    const callback = await API.get(`/reports?init=${moment(init).unix()}&end=${moment(end).unix()}`)
    return callback?.data
}, staleTime: 3000, gcTime: 1000 * 60 * 10 })

export default useReport